// Client for the Data Management → Data Tables drill-down (/api/data-tables).
import { headers } from "./classificationApi";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/data-tables`;

async function parse(res) {
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const d = body.detail;
    throw Object.assign(new Error(typeof d === "string" ? d : Array.isArray(d) ? d.map(x => x.msg).join("; ") : `Request failed (${res.status})`), { status: res.status });
  }
  return body;
}

const qs = (p) => {
  const s = new URLSearchParams(Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== "")).toString();
  return s ? `?${s}` : "";
};

export const listDataTables = () => fetch(BASE, { headers: headers(null, false) }).then(parse);
export const getTableRows = (name, params) => fetch(`${BASE}/${name}/rows${qs(params)}`, { headers: headers(null, false) }).then(parse);
export const refreshFromS3 = (actor) => fetch(`${BASE}/refresh`, { method: "POST", headers: headers(actor, true) }).then(parse);
